import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { filter, takeUntil, switchMap, map, finalize } from 'rxjs/operators';
import { Subject, Observable, EMPTY, from } from 'rxjs';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { ViolationService } from '../../violations-sets/violation-service/violation.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { PlannerHelpingService } from 'src/app/service/planning-services/planner-helping-service';

@Component({
  selector: 'app-trip-sheet',
  templateUrl: './trip-sheet.component.html',
  styleUrls: ['./trip-sheet.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripSheetComponent implements OnInit, OnDestroy {
  tripSheetRowPx = 7.619;
  @ViewChild("timer1", { static: false }) timer: any;
  tripSheetCushionBaseClass = 'absolute left-0 right-0 z-[5] box-border bg-gray-200 rounded-t-lg';
  duration = 20 * 1000; // 20 seconds
  driverList: any[] = [];
  user: any;
  isShowAllTrips = false;
  isAllowToHover = false;
  todayDate: any;
  skip = 0;
  driverTrips: any = {};
  allTrips: any[] = [];
  drivers: any[] = [];
  selectedDropdownIndex: any;
  toggleActionButtons: boolean = false;
  timeZone: string = '';
  search: string = '';
  stationManagerList: any[] = [];
  selectedServiceArea = '';
  filteredServiceAreas: any[] = [];
  serviceAreaList: any[] = [];
  preServiceAreas: any = {};
  selectedDriver: any;
  selectedStationManager: any;
  filteredDrivers: any[] = [];
  tripDetailModalObj: any;
  completedTripModalObj: any;
  isUnAssignEnabled = false;
  isCancelUnabled = false;
  showSlideFilter = false;
  timeCalibration = 'none';
  showBreak = true;
  preDriverList: any = {};
  driverShift = true;
  corporateList: any[] = [];
  preCooperates: any = {};
  levelOfServiceList: any[] = [];
  preLevelOfServices: any = {};
  spaceTypeList: any[] = [];
  preSpaceTypes: any = {};
  filteredCorporates: any[] = [];
  filteredLevelOfService: any[] = [];
  filteredSpaceTypes: any[] = [];
  driversPerPage = 25;
  isTimerEnabled = false;
  /** Visible driver column width: adjust by ±5, between min and max. */
  driversPerPageMin = 5;
  driversPerPageMax = Infinity;
  driversPerPageStep = 5;
  selectedSpaceType = '';
  selectedCooperate = '';
  selectedLOS = '';
  hoveredTrip = null;
  /** Left time rail: 30-min steps (0000, 0030, …, 2330); matches repeat(48, 80px) timeline rows */
  timeAxisHalfHourLabels: { label: string; onHour: boolean }[] = (() => {
    const ticks: { label: string; onHour: boolean }[] = [];
    for (let h = 0; h < 24; h++) {
      const hh = h < 10 ? '0' + h : String(h);
      ticks.push({ label: hh + '00', onHour: true });
      ticks.push({ label: hh + '30', onHour: false });
    }
    return ticks;
  })();
  status = "active";
  sortBy: 'trip' | 'vehicle' = 'trip';
  tripStatuses = [
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: false },
    { label: 'Arrived', status: 'arrived', isChecked: false },
    { label: 'In Progress', status: 'started', isChecked: false },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];
  isShowStatusDropdown = false;

  selectedDate: any;
  timeRange: any;
  scheduleTime: any;
  driverId: any;
  isRdispatcher = false;
  driversTimelines: any = {};
  isShowColorInformation = false;
  showUnassignedSidebar = true;
  undoStack: Array<{
    type: 'assign' | 'reschedule' | 'unassigned';
    trip: any;
    prevDriverId: any;
    prevStatus: string;
    prevJobStatus: string;
    driverName: string;
    prevScheduleTime?: string;
    prevAppointmentTime?: string | null;
  }> = [];
  version = '2';
  assignModalObj: any;
  componentType: any;
  secondaryCompType: any;
  /** ETA chain computed via setupTripsByPickup logic: driverId → tripId → { pickupEta, dropoffEta, travelMins } */
  driverEtaMap: { [driverId: string]: { [tripId: string]: { pickupEta: string; dropoffEta: string; travelMins: number } } } = {};
  /** Violation settings loaded from API — mirrors driver-load-v3 violations */
  violations: any = {};
  driverTripModalObj: any;
  timeRescheduleModalObj: {
    trip: any;
    oldScheduleTime: string;
    oldAppointmentTime: string | null;
    newScheduleTime: string;
    newAppointmentTime: string | null;
    oldTimeDisplay: string;
    newTimeDisplay: string;
  } | null = null;
  isGoogleMiles = false;

  /** Cached values to prevent re-computation on every change detection cycle */
  cachedDisplayDrivers: string[] = [];
  cachedDriverColumnCount: number = 0;
  cachedShiftBreakdowns: { [driverId: string]: any } = {};
  /** Cached tooltip titles — precomputed once, not on every CD cycle */
  cachedTripTitles: { [tripId: string]: string } = {};
  /** Cached grid-item styles to avoid returning new objects every CD cycle */
  cachedTripGridStyles: { [tripId: string]: { [key: string]: string } } = {};

  constructor(
    private cdr: ChangeDetectorRef,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private violationService: ViolationService,
    private assignTripService: AssigTripsService,
    private serviceArea: ServiceAreasService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private plannerHelpingService: PlannerHelpingService
  ) { }

  isFetchingComplete: boolean = false;

  refreshSubject = new Subject<void>();
  currentTimePosition: number = 0;
  timeInterval: any = null;


  ngOnInit(): void {
    this.getUser();
    this.setupRefreshListener();
  }

  setupRefreshListener() {
    this.refreshSubject.pipe(
      takeUntil(takeUntilDestroyed(this)),
      switchMap(() => {
        this.skip = 0;
        this.allTrips = [];
        this.driverTrips = [];
        this.isFetchingComplete = false;
        this.timeRange = [
          moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
          moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
        ]

        return this.fetchTripsInBatches().pipe(
          finalize(() => {
            console.log('Fetching trips completed or errored');
            this.isFetchingComplete = true;
          })
        );
      })
    ).subscribe();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          this.setupTimeIndicator();
          this.todayDate = moment.tz(this.timeZone).startOf("day").toISOString(),
            this.timeRange = [moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString()];


          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.getDriverList();
          this.cdr.markForCheck();
        }
      });
  }


  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            this.cdr.markForCheck();
          }
        });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            if (this.isRdispatcher) {
              data = data.filter(item => item.stationManager === this.user.sId);
            }

            this.driverList = data;
            this.getServiceAreas();
            this.getCorporate();
            this.getLevelOfService();
            this.getSpaceTypes();
            this.getViolationData();
            this.getRefreshTrips();
            this.getDriversTimelines();
            this.cdr.markForCheck();
          }
        },
      );
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  fetchTripsInBatches(): Observable<any> {
    const jobStatuses = ['pending'];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered', 'accepted');
        } else {
          jobStatuses.push(t.status);
        }
      }
    });

    const body = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.timeRange,
      showBreak: this.showBreak,
      skip: this.skip,
      jobStatuses
    };

    return this.assignTripService.getAssignList(body).pipe(
      switchMap(data => {
        if (data && data.length) {
          return from((async () => {
            if (this.timeCalibration && this.timeCalibration !== "none") {
              if (this.timeCalibration === "pickup-wise") {
                await this.plannerHelpingService.applyPickupWiseCalibration(this.isGoogleMiles, data, this.user);
              } else if (this.timeCalibration === "dropoff-wise") {
                await this.plannerHelpingService.applyDropoffWiseCalibration(this.isGoogleMiles, data, this.user);
              } else {
                await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.isGoogleMiles, data, this.user);
              }
            }
            return data;
          })()).pipe(
            switchMap(calibratedData => {
              this.allTrips = _.uniq([...this.allTrips, ...calibratedData], '_id');
              this.skip += calibratedData.length;
              return from(this.prepareDataFilters()).pipe(
                switchMap(() => this.fetchTripsInBatches())
              );
            })
          );
        } else {
          if (this.timer) {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.isAllowToHover = true;
          return from(this.prepareDataFilters()).pipe(
            map(() => EMPTY)
          );
        }
      })
    );
  }

  getRefreshTrips() {
    this.refreshSubject.next();
  }

  updateCurrentTimePosition() {
    const now = moment().tz(this.timeZone);
    const isToday = now.isSame(moment(this.todayDate).tz(this.timeZone), 'day');
    if (isToday) {
      this.currentTimePosition = this.getStartPoint(now.toISOString(), true);
    } else {
      this.currentTimePosition = 0;
    }
  }

  setupTimeIndicator() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.updateCurrentTimePosition();
    this.scrollToCurrentTime();
    this.timeInterval = setInterval(() => {
    this.updateCurrentTimePosition();
    console.log(`Updated currentTimePosition: ${this.currentTimePosition}`);
    if (this.isFetchingComplete) {
      this.filterTrips();
    }
    }, 60000);
  }

  scrollToCurrentTime() {
    setTimeout(() => {
      const container = document.getElementById('scrollContainer');
      if (container && this.currentTimePosition > 0) {
        // Grid: 64px header (row 1), then 7.619px per 5-min slot (row 2 = 00:00)
        const pixelTop = 64 + (this.currentTimePosition - 2) * this.tripSheetRowPx;
        container.scrollTop = Math.max(0, pixelTop - 200);
      }
    }, 500);
  }

  draggingUnassignedTrip: any = null;

  scrollToTripTime(trip: any) {
    const container = document.getElementById('scrollContainer');
    if (!container || !trip || !trip.scheduleTime) return;
    const slotRow = this.getStartPoint(trip.scheduleTime, true);
    const pixelTop = 64 + (slotRow - 2) * this.tripSheetRowPx;
    container.scrollTo({ top: Math.max(0, pixelTop - 200), behavior: 'smooth' });
    this.draggingUnassignedTrip = trip;
  }

  onUnassignedDragEnded() {
    this.draggingUnassignedTrip = null;
  }

  getDragHighlightWrapperStyle() {
    return {
      'grid-template-rows': '64px repeat(288, 7.619px) auto',
      'grid-column': '1 / span ' + this.getDriverColumnCount()
    };
  }

  getDragHighlightBlockStyle() {
    if (!this.draggingUnassignedTrip) return {};
    const rowStart = this.getStartPoint(this.draggingUnassignedTrip.scheduleTime, true);
    const rowSpan = this.getEndPoint(this.draggingUnassignedTrip.scheduleTime, this.draggingUnassignedTrip.appointmentTime);
    return {
      'grid-row': rowStart + ' / span ' + rowSpan,
      'grid-column': '1 / -1'
    };
  }

  async prepareDataFilters(): Promise<void> {
    this.stationManagerList = [];
    let serviceAreas = [];
    let cooperates = [];
    let levelOfServices = [];
    let spaceTypes = [];

    this.drivers = this.driverList.map(driver => ({
      _id: driver._id,
      displayName: driver.displayName,
      stationManager: driver.stationManager
    }));

    this.allTrips.forEach(trip => {
      if (trip.driver && trip.driver.stationManager) {

        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.stationManagerList.push(trip.driver.stationManager);
          }

        } else {
          this.stationManagerList.push(trip.driver.stationManager);
        }

      }

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }
      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }
    });

    this.drivers = _.uniq(this.drivers, '_id').sort();
    this.stationManagerList = _.uniq(this.stationManagerList).sort();
    cooperates = _.uniq(cooperates).sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }
    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }
    this.filteredDrivers = this.drivers;

    await this.filterTrips();
  }


  async filterTrips(): Promise<void> {

    let filterdataList = JSON.parse(JSON.stringify(this.allTrips));

    filterdataList = filterdataList.filter(trip => {

      let isNoDriver = !trip.driver;

      let isDriverExist = true;
      let isStaffExist = true;
      let isServiceAreaExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isCancelUnabled = true;
      let isSearchMatch = true;

      // ================= DRIVER FILTER =================
      if (this.selectedDriver && this.selectedDriver.length) {
        if (isNoDriver) {
          // allow no_driver unless search is applied
          isDriverExist = !this.search;
        } else {
          isDriverExist =
            trip.driver &&
            trip.driver._id &&
            this.selectedDriver.indexOf(trip.driver._id) !== -1;
        }
      }

      // ================= STATION MANAGER FILTER =================
      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (isNoDriver) {
          isStaffExist = !this.search;
        } else {
          isStaffExist =
            trip.driver &&
            trip.driver.stationManager &&
            this.selectedStationManager.indexOf(trip.driver.stationManager) !== -1;
        }
      }

      // ================= OTHER FILTERS =================
      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreaExist =
          trip.serviceArea &&
          this.selectedServiceArea.indexOf(trip.serviceArea) !== -1;
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        isCorporateExist =
          trip.cooperate &&
          this.selectedCooperate.indexOf(trip.cooperate) !== -1;
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        islosExist =
          trip.los &&
          this.selectedLOS.indexOf(trip.los) !== -1;
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        isSpaceTypeExist =
          trip.spaceType &&
          this.selectedSpaceType.indexOf(trip.spaceType) !== -1;
      }

      // ================= CANCELLED FILTER =================
      if (this.isCancelUnabled) {
        isCancelUnabled = trip.status === 'cancelled';
      }

      // ================= SEARCH FILTER =================
      if (this.search && this.search.trim().length > 0) {

        var searchTerm = this.search.toLowerCase();

        var isDriverName = false;
        var isMemberName = false;
        var isTripId = false;
        var isMemberPhone = false;

        if (trip.driver && trip.driver.displayName) {
          isDriverName =
            trip.driver.displayName.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.priorityClient && trip.priorityClient.displayName) {
          isMemberName =
            trip.priorityClient.displayName.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.tripId) {
          isTripId =
            trip.tripId.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.priorityClient && trip.priorityClient.cellPhone) {
          isMemberPhone =
            trip.priorityClient.cellPhone.toLowerCase().indexOf(searchTerm) !== -1;
        }

        isSearchMatch =
          isDriverName || isMemberName || isTripId || isMemberPhone;
      }

      // ================= FINAL RETURN =================
      return (
        isDriverExist &&
        isStaffExist &&
        isServiceAreaExist &&
        isCorporateExist &&
        islosExist &&
        isSpaceTypeExist &&
        isCancelUnabled &&
        (!this.search || isSearchMatch)
      );
    });

    // ================= GROUPING =================
    const groupedTrips = _.groupBy(filterdataList as any[], function (trip: any) {
      if (!trip.driver) return 'no_driver';

      if (typeof trip.driver === 'string') {
        return trip.driver;
      }

      return trip.driver._id ? trip.driver._id : 'no_driver';
    });

    // ================= DRIVER SORTING =================

    if (this.sortBy === 'vehicle') {
      // Sort by vehicle registration number (fleet.setiDecall or rigNumber) alphabetically.
      // Drivers without a vehicle go last.
      this.driverList.sort((a: any, b: any) => {
        const getVehicleReg = (driver: any): string | null => {
          if (driver && driver.fleet && driver.fleet.setiDecall) return driver.fleet.setiDecall;
          return null;
        };
        const aReg = getVehicleReg(a);
        const bReg = getVehicleReg(b);
        if (!aReg && !bReg) return 0;
        if (!aReg) return 1;
        if (!bReg) return -1;
        return aReg.localeCompare(bReg, undefined, { numeric: true, sensitivity: 'base' });
      });
    } else {
      // Sort by earliest trip's scheduleTime. Drivers with no trips go last.
      this.driverList.sort((a: any, b: any) => {
        const aTrips: any[] = groupedTrips[a._id];
        const bTrips: any[] = groupedTrips[b._id];

        const getEarliest = (trips: any[]): number => {
          if (!trips || trips.length === 0) return Number.MAX_SAFE_INTEGER;
          return trips.reduce((min: number, trip: any) => {
            const t = trip.scheduleTime ? (moment as any)(trip.scheduleTime).tz(this.timeZone).valueOf() : Number.MAX_SAFE_INTEGER;
            return t < min ? t : min;
          }, Number.MAX_SAFE_INTEGER);
        };

        return getEarliest(aTrips) - getEarliest(bTrips);
      });
    }

    let dTrips = {};

    const promises = this.driverList.map(async (driver) => {
      let trips = groupedTrips[driver._id];
      if (trips && trips.length) {
        dTrips[driver._id] = await this.checkOverlaps(trips);
      }
    });
    await Promise.all(promises);

    this.driverTrips = dTrips;

    // ================= NO DRIVER HANDLING =================
    if (groupedTrips['no_driver']) {

      let unassignedTrips = groupedTrips['no_driver'].filter(function (trip) {
        return trip.jobStatus === 'pending' || trip.status === 'unassigned';
      });

      if (unassignedTrips.length) {
        this.driverTrips['no_driver'] = unassignedTrips;
      }
    }

    // Rebuild all caches after filtering
    this.rebuildCaches();
    this.cdr.markForCheck();
  }

  onSelectTimeCalibration(timeCalibration) {
    this.timeCalibration = timeCalibration;
    this.getRefreshTrips();
  }

  /**
   * Processes a list of trips to detect overlaps and determine layout positioning.
   * It calculates how many columns are needed and groups overlapping trips.
   */
  async checkOverlaps(trips: any[]): Promise<any[]> {
    // 1. Guard clause for empty data
    if (!trips || trips.length === 0) return [];

    // 2. Sort trips: primary by start time, secondary by duration (longest first)
    const processed = [...trips].sort((a, b) => {
      const aStart = moment(a.scheduleTime).tz(this.timeZone).valueOf();
      const bStart = moment(b.scheduleTime).tz(this.timeZone).valueOf();

      if (aStart !== bStart) return aStart - bStart;

      // If they start at the same time, put the longer trip first to help the layout
      const aEnd = moment(a.appointmentTime || moment(a.scheduleTime).tz(this.timeZone).add(30, 'minutes')).tz(this.timeZone).valueOf();
      const bEnd = moment(b.appointmentTime || moment(b.scheduleTime).tz(this.timeZone).add(30, 'minutes')).tz(this.timeZone).valueOf();
      return bEnd - aEnd;
    });

    // 3. Initialize buffers and kick off async calculations
    processed.forEach(trip => {
      trip._tripSheetCushionMins = 15; // Default safety buffer
    });
    await this.computeTravelTimesInBackground(processed);

    // Helper: Calculates the precise start (with buffer) and end of a trip
    const overlapRange = (t: any) => {
      const cushionMins = this.getTripCushionMinutes(t);
      const sched = moment(t.scheduleTime).tz(this.timeZone);
      const start = sched.clone().subtract(cushionMins, 'minutes').valueOf();
      const end = t.appointmentTime
        ? moment(t.appointmentTime).tz(this.timeZone).valueOf()
        : sched.clone().add(30, 'minutes').valueOf();
      return { start, end };
    };

    // 4. Assign columns (subIndex)
    // We keep track of the 'end time' of the last trip in each column
    const columns: number[] = [];
    processed.forEach(trip => {
      const { start, end } = overlapRange(trip);

      // Find the first column where this trip can fit (starts after the previous trip ends)
      let colIdx = columns.findIndex(colEnd => start >= colEnd);

      if (colIdx === -1) {
        // Doesn't fit in any existing column? Create a new one.
        columns.push(end);
        trip.subIndex = columns.length - 1;
      } else {
        // Fits here? Update this column's end time.
        columns[colIdx] = end;
        trip.subIndex = colIdx;
      }
    });

    // 5. Cluster overlaps (Grouping)
    // This ensures all trips that overlap share the same 'subTotal' (total columns in that block)
    const n = processed.length;
    const visited = new Array(n).fill(false);

    for (let s = 0; s < n; s++) {
      if (visited[s]) continue;

      const cluster: number[] = [];
      const queue = [s];
      visited[s] = true;

      // Standard Breadth-First Search (BFS) to find all interconnected overlapping trips
      while (queue.length) {
        const j = queue.shift()!;
        cluster.push(j);
        const tj = overlapRange(processed[j]);

        for (let k = 0; k < n; k++) {
          if (visited[k]) continue;
          const tk = overlapRange(processed[k]);

          // Check if Trip J and Trip K physically overlap in time
          if (tj.start < tk.end && tj.end > tk.start) {
            visited[k] = true;
            queue.push(k);
          }
        }
      }

      // 6. Set the width (subTotal) for the cluster
      // The width of all trips in a cluster is determined by the max column index found
      let maxSub = 0;
      cluster.forEach(idx => {
        maxSub = Math.max(maxSub, processed[idx].subIndex || 0);
      });

      const subTotal = maxSub + 1;
      cluster.forEach(idx => {
        processed[idx].subTotal = subTotal;
      });
    }

    // 7. Final logic for calculating delays based on the new order
    this.computeDelayChain(processed);

    return processed;
  }

  /**
   * Compute travel times asynchronously in background, then update cushions and mark for check.
   * This avoids the fire-and-forget async forEach that was flooding the event loop.
   */
  async computeTravelTimesInBackground(trips: any[]): Promise<void> {
    let changed = false;
    for (const trip of trips) {
      const mins = await this.calculateTravelTime(trip, trips);
      if (mins !== 15) {
        trip._tripSheetCushionMins = mins;
        changed = true;
      }
    }
    if (changed) {
      this.rebuildCaches();
      this.cdr.markForCheck();
    }
  }

  computeDelayChain(trips: any[]): void {
    debugger;
    // 1. Context setup: Determine if we are looking at "Today"
    const realNow = moment().tz(this.timeZone);
    const selectedDay = moment(this.todayDate).tz(this.timeZone);
    const now = selectedDay.isSame(realNow, 'day') ? realNow : null;

    // 2. Filter out breaks (we only care about actual transport trips for the chain)
    const tripChain = trips.filter(t => !t.isBreakTrip);
    let prevEffectiveEnd: any = null;

    tripChain.forEach((trip, idx) => {
      // --- Step A: Calculate Trip Duration ---
      const cushionMins = Number(trip._tripSheetCushionMins || 15); // Buffer time between trips
      const sched = moment(trip.scheduleTime).tz(this.timeZone).subtract(cushionMins, 'minutes');
      const appt = trip.appointmentTime
        ? moment(trip.appointmentTime).tz(this.timeZone)
        : moment(trip.scheduleTime).tz(this.timeZone).add(30, 'minutes');

      const durationMins = Math.max(appt.diff(sched, 'minutes'), 5); // Ensure at least 5 mins

      let effectiveStart: any;
      let isDelayed = false;
      let delayMins = 0;
      let isDropOffDelayed = false;
      let isDropOffdelayMins = 0;

      // --- Step B: Calculate Predicted Start Time (The Chain Logic) ---
      if (idx === 0 || !prevEffectiveEnd) {
        // For the first trip, start time is just the scheduled time
        effectiveStart = sched.clone();
        // Check if it's already overdue (it's past the scheduled time and trip hasn't started)
        if (now && (trip.status === 'offered' || trip.status === 'accepted') && sched.isBefore(now, 'minute')) {
          isDelayed = true;
          delayMins = Math.round(now.diff(sched, 'minutes'));
          effectiveStart.add(cushionMins, 'minutes');
        }

      } else {
        console.log(`Previous trip effective end: ${prevEffectiveEnd.format('HH:mm')}`);
        // For subsequent trips, start time depends on when the PREVIOUS trip finished
        const earliestArrival = prevEffectiveEnd.clone();
        effectiveStart = earliestArrival;
console.log(`Current trip scheduled start: ${effectiveStart.format('HH:mm')}`);
        if (earliestArrival.isAfter(sched)) {
          // CASE 1: The previous trip ran late, pushing this trip back
          isDelayed = true;
          delayMins = Math.round(earliestArrival.diff(sched, 'minutes'));
        } else {
          // CASE 2: The driver is on time or early, so we stick to the schedule
          effectiveStart = sched.clone();

          // Still check if the "On Time" schedule is now in the past (overdue check)
          if (now && (trip.status === 'offered' || trip.status === 'accepted') && sched.isBefore(now, 'minute')) {
            isDelayed = true;
            delayMins = Math.round(now.diff(sched, 'minutes'));
            effectiveStart.add(cushionMins, 'minutes');
          }
        }
      }

      // --- Step C: Save Results ---
      trip._isPickupDelayed = isDelayed;
      trip._delayPickupMins = delayMins;

      // Convert the predicted start time to a 24hr string (e.g., "1430")
      if (isDelayed) {
        if (idx === 0 || !prevEffectiveEnd) {
          trip._forecastStartETA = effectiveStart
            .add(delayMins, 'minutes')
            .format('HHmm');
        } else {
          trip._forecastStartETA = effectiveStart
            .add(cushionMins, 'minutes')
            .format('HHmm');
        }
        prevEffectiveEnd = effectiveStart.clone();
        // first Trip and pickup is late
          prevEffectiveEnd.add(durationMins, 'minutes');


        trip._forecastEndETA = prevEffectiveEnd.format('HHmm');
      } else {
        trip._forecastStartETA = effectiveStart.format('HHmm');
        prevEffectiveEnd = effectiveStart.clone().add(durationMins, 'minutes');
        trip._forecastEndETA = prevEffectiveEnd.format('HHmm');
      }

      trip._travelToDropoff = durationMins;

      if(prevEffectiveEnd.isAfter(appt)) {
        isDropOffDelayed = true;
        isDropOffdelayMins = Math.round(prevEffectiveEnd.diff(appt, 'minutes'));
        trip._isDropOffDelayed = isDropOffDelayed;
        trip._dropOffDelayMins = isDropOffdelayMins;
      } else {
        trip._isDropOffDelayed = false;
        trip._dropOffDelayMins = 0;
      }

      // Inside the loop in computeDelayChain
      console.log(`-- ############ --`);
      console.log(`Trip: ${trip.tripId}`);
      console.log(`- Scheduled: ${sched.format('HH:mm')}`);
      console.log(`- Predicted Start: ${effectiveStart.format('HH:mm')}`);
      console.log(`- Predicted End: ${prevEffectiveEnd.format('HH:mm')}`);
      console.log(`- Is Delayed: ${isDelayed} (${delayMins} mins)`);
      console.log(`- Is Drop-off Delayed: ${isDropOffDelayed} (${isDropOffdelayMins} mins)`);

      // Update the "Ending Time" for the next trip in the loop to use
    });
  }


  async calculateTravelTime(currentTrip: any, uiTrips: any[]): Promise<number> {
    if (!uiTrips || !uiTrips.length || !this.timeZone) {
      return 15;
    }
    // uiTrips is already sorted by checkOverlaps (scheduleTime asc, appointmentTime desc for ties).
    // Do NOT re-sort here — a different sort key would pick the wrong predecessor for same-time trips.
    const idx = uiTrips.findIndex(
      t =>
        (currentTrip.tripId && t.tripId === currentTrip.tripId) ||
        (currentTrip._id && t._id === currentTrip._id)
    );

    if (idx <= 0) {
      return 15;
    }

    const prev = uiTrips[idx - 1];
    const lat1 = prev.jobDestinationLatitude;
    const lon1 = prev.jobDestinationLongitude;
    const lat2 = currentTrip.jobOriginLatitude;
    const lon2 = currentTrip.jobOriginLongitude;

    if (!lat1 || !lon1 || !lat2 || !lon2) {
      return 15;
    }
    const minutes = await this.calculateDistance(lat1, lon1, lat2, lon2);
    return minutes.duration;
  }

  getTripCushionMinutes(trip: any): number {
    if (trip && trip._tripSheetCushionMins != null && !isNaN(Number(trip._tripSheetCushionMins))) {
      return Number(trip._tripSheetCushionMins);
    }
    return 15;
  }

  getTripCushionRows(trip: any): number {
    return Math.ceil(this.getTripCushionMinutes(trip) / 5);
  }

  getTripCushionStripStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    const px = this.tripSheetRowPx;
    return {
      top: `calc(-${rows} * ${px}px)`,
      height: `calc(${rows} * ${px}px + 0.25rem)`,
    };
  }

  /** Dashed outline top offset must match cushion strip. */
  getTripCushionOutlineStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    return { top: `calc(-${rows} * ${this.tripSheetRowPx}px)` };
  }


  getStartPoint(date, b = true) {
    const time = moment(date).tz(this.timeZone);
    const totalMinutes = time.hours() * 60 + time.minutes();
    const slotIndex = Math.floor(totalMinutes / 5);

    // Row 1 is the 1.75rem header. 00:00 starts at Row 2.
    // If b is false (used for durations/offsets), we return the raw slot index + 1?
    // Actually, for duration span, we should use a separate method.
    return slotIndex + (b ? 2 : 1);
  }

  getEndPoint(dateOne, dateTwo) {
    const time1 = moment(dateOne).tz(this.timeZone);
    const time2 = moment(dateTwo).tz(this.timeZone);
    let diffInMinutes = time2.diff(time1, 'minutes');
    if (diffInMinutes < 5) diffInMinutes = 5;
    return Math.ceil(diffInMinutes / 5);
  }


  getShiftStartPoint(date, b = true) {
    const modifiedDate = moment(date, 'HHmm').toISOString();
    return this.getStartPoint(modifiedDate, b);
  }


  getShiftEndPoint(dateOne, dateTwo) {
    const modifiedDate1 = moment(dateOne, 'HHmm').toISOString();
    const modifiedDate2 = moment(dateTwo, 'HHmm').toISOString();
    return this.getEndPoint(modifiedDate1, modifiedDate2);
  }

  openDetailModal(trip) {
    this.tripDetailModalObj = trip
  }

  onTripDropped(event: CdkDragDrop<any>) {
    const trip = event.item.data;
    const driverId = event.container.data;
    const previousDriverId = event.previousContainer.data;

    if (driverId && driverId.startsWith('empty_')) {
      return;
    }

    // Same column: attempt Y-axis time reschedule (only for unassigned/offered)
    if (driverId === previousDriverId) {
      if (
        driverId !== 'no_driver' &&
        (trip.status === 'unassigned' || trip.status === 'offered') &&
        Math.abs(event.distance.y) >= this.tripSheetRowPx
      ) {
        this.initiateTimeReschedule(trip, event.distance.y);
      }
      return;
    }

    const targetDriver = (this.preDriverList as any)[driverId];
    const alertMessage = this.getAlertMessage(driverId, targetDriver);

    // Capture pre-state for undo
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevStatus: string = trip.status;
    const prevJobStatus: string = trip.jobStatus;
    const prevDriverObj = trip.driver ? (typeof trip.driver === 'object' ? { ...trip.driver } : (this.preDriverList as any)[trip.driver]) : null;
    const prevDriverName = prevDriverObj ? prevDriverObj.displayName : 'Unassigned';

    sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {

          // Assign to a driver
            // Push undo entry before mutating
            this.undoStack.push({ type: 'assign', trip, prevDriverId, prevStatus, prevJobStatus, driverName: prevDriverName });
            this.cdr.detectChanges();

          if (driverId === 'no_driver') {
            trip.jobStatus = 'pending';
            trip.status = 'unassigned';
            trip.driver = null; // Clear driver
            this.updateSingleTrip(trip);
          } else {
            const fullDriver = (this.preDriverList as any)[driverId];
            trip.driver = fullDriver ? { ...fullDriver } : { _id: driverId };
            trip.status = 'offered';
            trip.jobStatus = 'offered';
            this.assignSingleTrip(trip);
          }

          // Update in allTrips so filtration picks it up
            const tripIndex = this.allTrips.findIndex(t => t._id === trip._id);
            if (tripIndex !== -1) {
              this.allTrips[tripIndex] = trip;
              this.prepareDataFilters();
            }

        }
      });
  }
  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }



  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  showDriverBreak(val) {
    this.showBreak = val
    this.getRefreshTrips();
  }

  onResetTime() {
    this.timeRange = [
      moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
      moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
    ]
    this.getRefreshTrips();
  }
  onTimeChange(event) {
    this.driversTimelines = {};
    // debugger;
    this.timeRange = [event[0].toISOString(), event[1].toISOString()];
    this.getRefreshTrips();
  }

  onDateChange(event) {
    this.todayDate = event.toISOString();
    this.timeRange = [event.toISOString(), event.endOf("day").toISOString()];
    this.updateCurrentTimePosition();
    this.driversTimelines = {};
    // this.todayDate =
    //   [
    //     event[0].toISOString(),
    //     event[1].endOf("day").toISOString(),
    //   ]
    this.isAllowToHover = false;
    this.getRefreshTrips();
    this.getDriversTimelines();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), max: moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString() }
  }



  getViolationData() {
    this.violationService.getViolationData()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.violations = data;
          this.cdr.markForCheck();
        }
      });
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onChangeStatus() {
    this.isAllowToHover = false;
    this.getRefreshTrips();
  }



  onEditTrip(trip) {
    if (trip) {
      trip.driver = this.driverList.find(driver => driver._id === trip.driver);
      this.allTrips.push(trip);
      this.prepareDataFilters();
      this.scheduleTime = null;
      this.driverId = null;
    }
  }

  getDriversTimelines() {
    const queryString = {};
    const range = [moment(this.todayDate).startOf("day").toISOString(), moment(this.todayDate).endOf("day").toISOString()];
    queryString['dates'] = { "startDate": range[0], "endDate": range[1] };
    this.driverService
      .getAllDriverTimelines(queryString)
      .subscribe(data => {
        if (data && data.length) {
          this.driversTimelines = data.reduce((acc, item) => {
            const { _id, jobs } = item;
            const driverId = _id.driver;
            acc[driverId] = {
              checkin: jobs && jobs.length ? jobs[0].checkin : null,
              checkout: jobs && jobs.length ? jobs[0].checkout : null
            }
            return acc;
          }, {});
          this.rebuildCaches();
          this.cdr.markForCheck();
        }
      });
  }

  shiftBreakdown(driverId) {
    const shift = this.driversTimelines[driverId];
    const driverTrips = this.driverTrips[driverId] || [];
    const breakdown = {};

    // 1. Check if we have Actual/Logged Shift data
    if (shift && shift.checkin) {
      let { checkin, checkout } = shift;
      const checkinMoment = moment(checkin).tz(this.timeZone);
      const checkinHours = checkinMoment.format("HHmm");

      if (!checkout) {
        // Active Shift (Not Ended)
        const supposedCheckout = checkinMoment.clone().add(8, 'hours');
        const supposedCheckoutHours = supposedCheckout.format("HHmm");

        breakdown['shift_started.regular_window'] = {
          start: this.getShiftStartPoint(checkinHours, true),
          end: this.getShiftEndPoint(checkinHours, supposedCheckoutHours)
        };

        // Check for Overtime if trips exist beyond supposed checkout
        if (driverTrips.length) {
          const lastTrip = driverTrips[driverTrips.length - 1];
          const apt = moment(lastTrip.appointmentTime || moment(lastTrip.scheduleTime).add(30, 'm')).tz(this.timeZone);
          if (apt.isAfter(supposedCheckout)) {
            breakdown['shift_started.overtime_window'] = {
              start: this.getShiftStartPoint(supposedCheckoutHours, true),
              end: this.getShiftEndPoint(supposedCheckoutHours, apt.format("HHmm"))
            };
          }
        }
      } else {
        // Completed Shift
        const checkoutMoment = moment(checkout).tz(this.timeZone);
        const checkoutHours = checkoutMoment.format("HHmm");
        const totalHoursWorked = checkoutMoment.diff(checkinMoment, 'hours', true);

        if (totalHoursWorked > 8) {
          const regularShiftEndHours = checkinMoment.clone().add(8, 'hours').format('HHmm');
          breakdown['shift_ended.regular_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, regularShiftEndHours)
          };
          breakdown['shift_ended.overtime_window'] = {
            start: this.getShiftStartPoint(regularShiftEndHours, true),
            end: this.getShiftEndPoint(regularShiftEndHours, checkoutHours)
          };
        } else {
          breakdown['shift_ended.regular_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, checkoutHours)
          };
        }
      }
      return breakdown;
    }

    // 2. Fallback to Scheduled Shift if not checked in
    const driver = this.driverList.find(d => d._id === driverId);
    if (driver && driver.shifts) {
      const now = moment(this.todayDate).tz(this.timeZone);
      const scheduledShift = driver.shifts.find(s => s.isEnabled && s.day === now.day());

      if (scheduledShift && scheduledShift.checkin && scheduledShift.checkout) {
        breakdown['shift_started.regular_window'] = {
          start: this.getShiftStartPoint(scheduledShift.checkin, true),
          end: this.getShiftEndPoint(scheduledShift.checkin, scheduledShift.checkout)
        };
        return breakdown;
      }
    }

    return null;
  }


  getAlertMessage(zoneId: string, targetDriver: any): string {
    return zoneId === 'no_driver'
      ? 'Are you sure you want to unassign this trip?'
      : `Are you sure you want to assign this trip to ${targetDriver.displayName}?`;
  }



  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  undoLastAssignment() {
    if (!this.undoStack.length) return;
    const entry = this.undoStack.pop()!;

    const trips: any[] = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === entry.trip._id);
    const liveTripObj: any = tripIndex !== -1 ? trips[tripIndex] : entry.trip;

    if (entry.type === 'reschedule') {
      liveTripObj.scheduleTime = entry.prevScheduleTime;
      liveTripObj.appointmentTime = entry.prevAppointmentTime;

      if (tripIndex !== -1) {
        trips[tripIndex] = { ...liveTripObj };
      }

      this.prepareDataFilters();
      this.cdr.detectChanges();
      this.updateSingleTrip({ ...liveTripObj });
      return;
    }

    // type === 'assign'
    const prevDriverObj = entry.prevDriverId
      ? (this.preDriverList as any)[entry.prevDriverId]
      : null;

    liveTripObj.driver = prevDriverObj ? { ...prevDriverObj } : null;
    liveTripObj.status = entry.prevStatus;
    liveTripObj.jobStatus = entry.prevJobStatus;

    if (tripIndex !== -1) {
      trips[tripIndex] = { ...liveTripObj };
    }

    this.prepareDataFilters();
    this.cdr.detectChanges();

    const payload = { ...liveTripObj };
    if (entry.prevDriverId) {
      this.assignSingleTrip(payload);
    } else {
      payload.driver = null;
      this.updateSingleTrip(payload);
    }
  }

  onClickTripCard(trip) {
    if (trip.isBreakTrip) {
      return;
    }
    if (trip.job) {
      this.viewCompletedTripDetails(trip);
    } else {
      this.openDetailModal(trip);
    }
  }

  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.undoStack = [];
  }

  getDisplayDrivers() {
    return this.cachedDisplayDrivers;
  }

  computeDisplayDrivers(): string[] {
    const filteredSet = new Set((this.filteredDrivers || []).map(d => d._id));
    const result = (this.driverList as any[])
      .filter(d => filteredSet.has(d._id))
      .map(d => d._id as string);

    while (result.length < this.driversPerPage) {
      result.push(`empty_${result.length}`);
    }

    return result;
  }

  onLimitChange() {
    let n = Number(this.driversPerPage);
    if (isNaN(n)) {
      n = this.driversPerPageMin;
    }
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    n = Math.round(n / this.driversPerPageStep) * this.driversPerPageStep;
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    this.driversPerPage = n;
  }

  incrementDriversPerPage() {
    const next = this.driversPerPage + this.driversPerPageStep;
    if (next <= this.driversPerPageMax) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  decrementDriversPerPage() {
    const next = this.driversPerPage - this.driversPerPageStep;
    if (next >= this.driversPerPageMin) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  getDriverName(driverId: string) {
    if (driverId === 'no_driver') return 'Unassigned';
    if (driverId.startsWith('empty_')) return '';
    const driver = this.preDriverList[driverId];
    return (driver && driver.displayName) || 'Unknown';
  }

  getDriverImage(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) {
      return 'assets/images/placeholders/driver-placeholder.png';
    }
    const driver = this.preDriverList[driverId];
    return (driver && driver.profileImageURL) || 'assets/images/placeholders/driver-placeholder.png';
  }

  getDriverRigNumber(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) return 'N/A';
    const driver = this.preDriverList[driverId];
    if (driver && driver.fleet && driver.fleet.setiDecall) {
      return driver.fleet.setiDecall;
    }
    return 'N/A';
  }

  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.isGoogleMiles) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assignTripService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }

  // ─── Tooltip ─────────────────────────────────────────────────────────────────
  /** Native tooltip (title) for trip row hover — returns cached string (not async). */
  getTripCardTitle(trip: any): string | null {
    if (!trip || !trip._id) return null;
    return this.cachedTripTitles[trip._id] || null;
  }


  getDriverColumnCount() {
    return this.cachedDriverColumnCount;
  }

  computeDriverColumnCount(): number {
    const total = (this.filteredDrivers || []).length;
    return Math.max(total, this.driversPerPage);
  }

  trackByDriverId(index: number, driverId: string) {
    return driverId;
  }

  trackByTripId(_index: number, trip: any) {
    return trip._id;
  }

  /**
   * One column per driver; overlapping trips split width by subTotal (e.g. 2 → 50% / 50%).
   * Avoids repeat(globalMaxSubTotal) which left empty tracks when another part of the day had more overlaps.
   */
  getTripGridItemStyle(trip: any): { [key: string]: string } {
    const cached = this.cachedTripGridStyles[trip._id];
    if (cached) return cached;
    return this.computeTripGridItemStyle(trip);
  }

  computeTripGridItemStyle(trip: any): { [key: string]: string } {
    const subTotal = trip.subTotal || 1;
    const subIndex = trip.subIndex || 0;
    const gridRow =
      this.getStartPoint(trip.scheduleTime, true) +
      ' / span ' +
      this.getEndPoint(trip.scheduleTime, trip.appointmentTime);
    const style: { [key: string]: string } = {
      'grid-row': gridRow,
      'grid-column': '1 / -1',
      'justify-self': 'start',
      'z-index': String(subIndex + 1),
      'box-sizing': 'border-box',
    };
    if (subTotal <= 1) {
      style['width'] = '100%';
      style['margin-left'] = '0%';
    } else {
      style['width'] = 100 / subTotal + '%';
      style['margin-left'] = (100 / subTotal) * subIndex + '%';
    }
    this.cachedTripGridStyles[trip._id] = style;
    return style;
  }

  initiateTimeReschedule(trip: any, deltaY: number) {
    const minutesDelta = Math.round(deltaY / this.tripSheetRowPx) * 5;
    if (minutesDelta === 0) return;

    const oldMoment = (moment as any)(trip.scheduleTime).tz(this.timeZone);
    const newMoment = oldMoment.clone().add(minutesDelta, 'minutes');
    const newScheduleTime = newMoment.toISOString();
    const newAppointmentTime = trip.appointmentTime
      ? (moment as any)(trip.appointmentTime).tz(this.timeZone).add(minutesDelta, 'minutes').toISOString()
      : null;

    this.timeRescheduleModalObj = {
      trip,
      oldScheduleTime: trip.scheduleTime,
      oldAppointmentTime: trip.appointmentTime || null,
      newScheduleTime,
      newAppointmentTime,
      oldTimeDisplay: oldMoment.format('HHmm'),
      newTimeDisplay: newMoment.format('HHmm')
    };
  }

  confirmTimeReschedule() {
    if (!this.timeRescheduleModalObj) return;
    const { trip, newScheduleTime, newAppointmentTime, oldScheduleTime, oldAppointmentTime } = this.timeRescheduleModalObj;

    // Push undo entry before mutating
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevDriverObj = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver : (this.preDriverList as any)[trip.driver])
      : null;
    this.undoStack.push({
      type: 'reschedule',
      trip,
      prevDriverId,
      prevStatus: trip.status,
      prevJobStatus: trip.jobStatus,
      driverName: prevDriverObj ? prevDriverObj.displayName : 'Unassigned',
      prevScheduleTime: oldScheduleTime,
      prevAppointmentTime: oldAppointmentTime
    });
    this.cdr.detectChanges();

    const trips = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === trip._id);
    if (tripIndex !== -1) {
      trips[tripIndex] = {
        ...trips[tripIndex],
        scheduleTime: newScheduleTime,
        appointmentTime: newAppointmentTime
      };
      this.prepareDataFilters();
    }

    const payload = { ...trip, scheduleTime: newScheduleTime, appointmentTime: newAppointmentTime };
    this.updateSingleTrip(payload);
    this.timeRescheduleModalObj = null;
  }

  cancelTimeReschedule() {
    this.timeRescheduleModalObj = null;
  }



  openAssignModal(trip) {
    this.assignModalObj = trip;
    this.componentType = 'unassign';
  }

  onAssignTrip(evt) {
    if (evt) {
      this.assignModalObj = null;
      this.getRefreshTrips();
    }
  }

  onCloseAssignModal() {
    this.assignModalObj = null;
  }

  openDriverTripDetailModal(id) {
    this.driverTripModalObj = id;
  }

  closeModal(evt) {
    this.driverTripModalObj = null;
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.getRefreshTrips();
    } else {
      this.timer.init();
    }
  }

  onTimerComplete(): void {
    this.timer.init();
    this.getRefreshTrips();
  }

  onChangeMilesCalculation() {
    this.getRefreshTrips();
  }


  /**
   * Rebuild all cached values used by template getters.
   * Called once after filterTrips() finishes, so Angular's CD reads stable values.
   */
  rebuildCaches() {
    // 1. Display drivers & column count
    this.cachedDisplayDrivers = this.computeDisplayDrivers();
    this.cachedDriverColumnCount = this.computeDriverColumnCount();

    // 2. Shift breakdowns per driver
    const breakdowns: { [driverId: string]: any } = {};
    for (const driverId of this.cachedDisplayDrivers) {
      if (!driverId.startsWith('empty_')) {
        breakdowns[driverId] = this.computeShiftBreakdown(driverId);
      }
    }
    this.cachedShiftBreakdowns = breakdowns;

    // 3. Trip grid styles
    this.cachedTripGridStyles = {};
    for (const driverId of Object.keys(this.driverTrips)) {
      const trips = this.driverTrips[driverId];
      if (trips && trips.length) {
        for (const trip of trips) {
          this.computeTripGridItemStyle(trip);
        }
      }
    }

    // 4. Tooltip titles — precompute synchronous part, async parts fill in later
    this.precomputeTripTitles();
  }

  /**
   * Cached shiftBreakdown accessor for template.
   */
  getCachedShiftBreakdown(driverId: string): any {
    return this.cachedShiftBreakdowns[driverId] || null;
  }

  /**
   * Actual shift breakdown computation — moved from shiftBreakdown() to avoid template recomputing.
   */
  computeShiftBreakdown(driverId: string) {
    return this.shiftBreakdown(driverId);
  }

  /**
   * Precompute tooltip titles for all visible trips.
   */
  precomputeTripTitles() {
    this.cachedTripTitles = {};
    for (const driverId of Object.keys(this.driverTrips)) {
      const trips = this.driverTrips[driverId];
      if (!trips) continue;
      for (const trip of trips) {
        if (trip && trip._id && trip.scheduleTime) {
          // Build sync tooltip immediately
          this.cachedTripTitles[trip._id] = this.buildTripTooltipSync(trip);
        }
      }
    }
  }

  /**
   * Synchronous tooltip builder — no async/await calls.
   * Avoids binding promises to [attr.title] which caused infinite CD loops.
   */
  buildTripTooltipSync(trip: any): string {
    const tz = this.timeZone;
    const start = moment.tz(trip.scheduleTime, tz).format('HHmm');
    const end = moment.tz(trip.appointmentTime || trip.scheduleTime, tz).format('HHmm');

    if (trip.isBreakTrip) return `${start} – ${end} (break)`;

    const lines: string[] = [];
    lines.push(`Scheduled:  ${start} → ${end}`);
    lines.push(`--------------`);

    if (trip._tripSheetCushionMins) {
      lines.push(`Travel(to P): ${trip._tripSheetCushionMins} min`);
    }

    if (trip._travelToDropoff) {
      lines.push(`Travel(to D): ${trip._travelToDropoff} min`);
    }
    lines.push(`--------------`);
    const jobStatus = trip.jobStatus;
    const trackInfo = trip.job && trip.job.trackInfoJob;

    if (trip.status === 'finished') {
      if (trackInfo && trackInfo.jobArrived && trackInfo.jobArrived.time) {
        lines.push(`Arrived(P): ${moment.tz(trackInfo.jobArrived.time, tz).format('HHmm')}`);
      } else if (trip._forecastStartETA) {
        lines.push(`Est. ETA(P): ${trip._forecastStartETA}`);
      }
      if (trackInfo && trackInfo.jobFinished && trackInfo.jobFinished.time) {
        lines.push(`Completed: ${moment.tz(trackInfo.jobFinished.time, tz).format('HHmm')}`);
      } else if ( trip._forecastEndETA) {
        lines.push(`Est. ETA(D): ${trip._forecastEndETA}`);
      }
    } else if (jobStatus === 'arrived' || jobStatus === 'started') {
      if (trackInfo && trackInfo.jobArrived && trackInfo.jobArrived.time) {
        const arrivedAt = moment.tz(trackInfo.jobArrived.time, tz);
        const scheduledAt = moment.tz(trip.scheduleTime, tz);
        const diff = arrivedAt.diff(scheduledAt, 'minutes');
        const diffStr = diff <= 0 ? `${Math.abs(diff)} min early` : `${diff} min late`;
        lines.push(`Arrived(P): ${arrivedAt.format('HHmm')} (${diffStr})`);
      } else if (trip._forecastStartETA) {
        lines.push(`Est. ETA(P): ${trip._forecastStartETA}`);
      }
      if (trip._forecastEndETA) {
        lines.push(`Est. ETA(D): ${trip._forecastEndETA}`);
      }
    } else if (jobStatus === 'onway') {
      if (trip._forecastStartETA) {
        lines.push(`Est. ETA(P): ${trip._forecastStartETA}`);
      }
      if (trip._forecastEndETA) {
        lines.push(`Est. ETA(D): ${trip._forecastEndETA}`);
      }
    } else {

      if (trip._forecastStartETA) {
        lines.push(`Est. ETA(P): ${trip._forecastStartETA}`);
      }

      if (trip._forecastEndETA) {
        lines.push(`Est. ETA(D): ${trip._forecastEndETA}`);
      }

      if (trip._isPickupDelayed || trip._isDropOffDelayed) {

         lines.push(`--------------`);

        if (trip._isPickupDelayed && trip._delayPickupMins > 0) {
          lines.push(`⚠ Late(P) +${trip._delayPickupMins} min`);
        }

        if (trip._isDropOffDelayed && trip._dropOffDelayMins > 0) {
          lines.push(`⚠ Late(D) +${trip._dropOffDelayMins} min`);
        }
      }
    }

    return lines.join('\n');
  }

}



